import React from 'react';
import { Link } from 'react-router-dom';

import {
    Bumper,
    Card,
    ContentScroller,
    HorizontalFlexWrapper,
} from 'styles/shared';
import { Fonts, spacing } from 'styles/theme';

export const CoachResources = () => (
    <ContentScroller>
        <Bumper />
        <Bumper />
        <Bumper />
        <Bumper />
        <Card>
            <Fonts.Heading5>{`Resources:`}</Fonts.Heading5>
            <Bumper />
            <HorizontalFlexWrapper $isContentSpread>
                <Link
                    to="https://www.notion.so/thegrandworld/The-Grand-Coaching-Hub-7fef7bc9ada5414ab03e35cc6cd1577c"
                    target="_blank"
                    rel="noreferrer"
                >
                    <Fonts.Medium $isUnderlined>
                        {`Coaches Hub (Notion)`}
                    </Fonts.Medium>
                </Link>
                <Bumper $minWidth={spacing.xxxLarge} />
                <Link
                    to="https://thegrandcommuity.slack.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    <Fonts.Medium
                        $isUnderlined
                    >{`Slack Community`}</Fonts.Medium>
                </Link>
                <Bumper $minWidth={spacing.xxxLarge} />
                <Link to="?modalContent=feedback">
                    <Fonts.Medium $isUnderlined>{`Feedback Tool`}</Fonts.Medium>
                </Link>
            </HorizontalFlexWrapper>
        </Card>
    </ContentScroller>
);
